import fileDownload from 'js-file-download';
import {toast} from 'react-toastify';
import i18n from '../i18n';
import {ExportTypes} from '../incase-domain/common/exportTypes';
import {IElement} from '../incase-domain/elements';
import {ISlideChangeable} from '../incase-domain/elements/base/slideChangeable';
import {ELEMENT} from '../incase-domain/elements/base/ElementTypes';
import {convertElementMediaToBase64} from './elementMediaBase64';
import {encodeExport} from './exportEncoding';

const defaultElementProperties = {
    id: '',
    keyIndex: '',
    elementIndex: 0,
    slideId: '',
    elementToClickForDisplay: [],
    elementToDisplayAfterClick: [],
    clearAfterClicked: false,
};

function isSlideChangeable(element: IElement): element is IElement & ISlideChangeable {
    return (element as ISlideChangeable).slideChange !== undefined;
}

export const exportElement = async (index: number, elements: IElement[]): Promise<void> => {
    const source = elements[index] as IElement;
    const element = {...source, ...defaultElementProperties} as IElement;

    if (isSlideChangeable(element)) {
        element.slideChange = {slideId: '', name: ''};
    }

    if (element.type === ELEMENT.YES_NO_QUESTION) {
        element.slideChange = [];
    }

    try {
        const elementWithBase64 = await convertElementMediaToBase64(element);
        const exportedElement = {data: elementWithBase64, type: ExportTypes.SLIDE_ELEMENT};
        fileDownload(encodeExport(exportedElement), `${element.name.trim().replace(/\s+/g, '_')}.nbl`);
    } catch {
        toast.error(i18n.t('toasts.exportElementError'));
    }
};
